/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetAssetPositionRestrictionsOptions,
  GetAssetPositionRestrictionsResponses,
} from '../types/GetAssetPositionRestrictions'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Returns every capped asset, for both the ordinary and the trading challenge audience.
 * @summary Get the open position size limits of every asset.
 * {@link /v1/assets/restrictions}
 */
export function getAssetPositionRestrictions<ThrowOnError extends boolean = true>(
  options: Options<GetAssetPositionRestrictionsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetAssetPositionRestrictionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/assets/restrictions',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAssetPositionRestrictionsResponses, ThrowOnError>>,
  )
}
